import MainBoard from "./MainBoard";
import { NavigationItem } from "../../../core/navigation/types";
import { mainBoardLocation, baseEdit } from "./Locations";
import { EditOrderPage } from "../orders/EditOrderPage"

export const mainBoardComponents: NavigationItem[] = [
	{
		Component: MainBoard,
		isMenuItem: true,
		path: mainBoardLocation,
		notifications: true,
	},
	{
		Component: EditOrderPage,
		isMenuItem: false,
		path: baseEdit,
	},
];
